import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "uPQVgH",
    defaultMessage: "Push products to Google Merchant Center",
    description: "google export modal title",
  },
  description: {
    id: "n5BWsU",
    defaultMessage:
      "Push every product that is published and visible in the selected channel to Google Merchant Center via the Content API. The service account key is used only for this request and is never stored.",
    description: "google export modal description",
  },
  merchantIdLabel: {
    id: "42sctk",
    defaultMessage: "Merchant Center account ID",
    description: "merchant id field label",
  },
  serviceAccountLabel: {
    id: "vlEHg/",
    defaultMessage: "Service account key (JSON)",
    description: "service account key field label",
  },
  serviceAccountHelp: {
    id: "Xr2jPj",
    defaultMessage:
      "Paste the contents of your Google service account JSON key. It is not saved — it lives only in this browser tab and the single request that pushes your products.",
    description: "service account key field help",
  },
  storefrontUrlLabel: {
    id: "UH4h9V",
    defaultMessage: "Storefront URL (optional)",
    description: "storefront url field label",
  },
  submit: {
    id: "JGZC4L",
    defaultMessage: "Push to Google",
    description: "submit push button",
  },
  resultSuccess: {
    id: "e8p5Ye",
    defaultMessage: "{succeeded} of {total} products accepted by Google.",
    description: "push result success summary",
  },
  resultFailed: {
    id: "HGDCOQ",
    defaultMessage: "{failed} products were rejected.",
    description: "push result failure summary",
  },
  resultFeedUrl: {
    id: "8uoQM9",
    defaultMessage: "Crawlable feed URL (add as a scheduled fetch in Merchant Center):",
    description: "push result feed url label",
  },
  toastStartedTitle: {
    id: "jFLs1D",
    defaultMessage: "Pushing products to Google…",
    description: "push started toast",
  },
  toastSuccessTitle: {
    id: "e+Fpk1",
    defaultMessage: "Push finished",
    description: "push success toast",
  },
  toastErrorTitle: {
    id: "C+1TiI",
    defaultMessage: "Push failed",
    description: "push error toast",
  },
});
